import styled from "styled-components";
export const TooltipContent = styled.div `
    & ul {
        padding-left: 24px;
    }
`;
